import React from 'react'
import {connect} from 'react-redux'
import R from 'ramda'
import {estatePhoto} from 'conf'
import {FormattedMessage} from 'react-intl'

import photoUrlFormatter from '../utils/photoUrlFormatter' 

import EstatePartner from './EstatePartner'
import LikeButton from './LikeButton'
import Spacer from './Spacer'
import Icon from './Icon'
import ImageWithLoaderAndDefaultForPopup from './ImageWithLoaderAndDefaultForPopup'
import EstateDescription from './EstateDescription'
import StatelessFuncToPureComponent from './StatelessFuncToPureComponent'

import getCurrentQuery from '../utils/getCurrentQuery'
import {poiToString} from '../utils/queryObjectMapper'
import {estateDetailsPage} from 'conf'


const EstatePopupCard = ({proximityScore, id, photos, address, price, rooms, partner, like, providerUrl,pertinenceScore}) => {
  const fileName = R.path(['0', 'url'], photos)
  const formattedFileName = fileName ? photoUrlFormatter(fileName, id, 300) : undefined
  const photoUrl = formattedFileName ? estatePhoto(formattedFileName) : undefined
  const query = getCurrentQuery()
  const pois = R.map(poiToString, query.pois).join('/')
  const detailsUrl = estateDetailsPage(id, pois)

  if(typeof like === undefined)
    like = false;

  if(pertinenceScore != -999 && proximityScore != 0)
  {
    // The estate has both a pertinenceScore and a proximityScore.

    const details = "Fiche Détaillée";

    return <div className="estate">
      <div className="panel panel-default">
        <div className="panel-body">
          
          <div className="media">
            <div className="media-left">

              <div style={{display:'flex', flexDirection:'column', flexBasis:'50%', position:'absolute'}}>
                <EstatePartner partner={partner} providerUrl={providerUrl} selected={true}/>
              </div>

              <ImageWithLoaderAndDefaultForPopup defaultSrc="images/estate/maison_600.png"
                                         imgSrc={photoUrl}/>  

            </div>
            <div className="media-body">
              <span>
                {price} $
              </span>
              <br></br>
              {address}
              <br></br>
              <Icon name="bed">
                {rooms}
              </Icon>
              <br></br>
              <span>
                {Math.round(proximityScore/60)} min
              </span>
              <br></br>
              <a href={detailsUrl} target='_blank' rel='noopener' style={{marginRight:'5px'}}>
                {details}
              </a>
           </div>
          </div>
        </div>
      </div>
    </div>
  }
  else if(proximityScore == 0)
  {
    // The estate has only a pertinenceScore (no POI).

    const details = "Fiche Détaillée";

    return <div className="estate">
      <div className="panel panel-default">
        <div className="panel-body">
          
          <div className="media">
            <div className="media-left">

              <div style={{display:'flex', flexDirection:'column', flexBasis:'50%', position:'absolute'}}>
                <EstatePartner partner={partner} providerUrl={providerUrl} selected={true}/>
              </div>

              <ImageWithLoaderAndDefaultForPopup defaultSrc="images/estate/maison_600.png"
                                         imgSrc={photoUrl}/>  
            </div>
            <div className="media-body">
              <span>
                {price} $
              </span>
              <br></br>
              {address}
              <br></br>
              <Icon name="bed">
                {rooms}
              </Icon>
              <br></br>
              <span>
                Score: {pertinenceScore}
              </span>
              <br></br>
              <a href={detailsUrl} target='_blank' rel='noopener' style={{marginRight:'5px'}}>
                {details}
              </a>

           </div>
          </div>
        </div>
      </div>
    </div>
  }
  else
  {
    // The estate has neither a pertinenceScore nor a proximityScore. (The estate appears in grey on the map.) 

    const details = "Fiche Détaillée";
    
    return <div className="estate">
      <div className="panel panel-default">
        <div className="panel-body">
          
          <div className="media">
            <div className="media-left">

              <div style={{display:'flex', flexDirection:'column', flexBasis:'50%', position:'absolute'}}>
                <EstatePartner partner={partner} providerUrl={providerUrl} selected={false}/>
              </div>

              <ImageWithLoaderAndDefaultForPopup defaultSrc="images/estate/maison_600.png"
                                         imgSrc={photoUrl}/>  
            </div>
            <div className="media-body">
              <span>
                {price} $
              </span>
              <br></br>
              {address}
              <br></br>
              <Icon name="bed">
                {rooms}
              </Icon>
              <br/>
              <a href={detailsUrl} target='_blank' rel='noopener' style={{marginRight:'5px'}}>
                {details}
              </a>

           </div>
          </div>
        </div>
      </div>
    </div>
  }
}


EstatePopupCard.PropTypes = {
  id: React.PropTypes.number.isRequired,
  like: React.PropTypes.bool,
  address: React.PropTypes.string.isRequired,
  price: React.PropTypes.number.isRequired,
  rooms: React.PropTypes.number.isRequired,
  photos: React.PropTypes.array.isRequired,
  partner: React.PropTypes.string.isRequired,
  providerUrl: React.PropTypes.string.isRequired,
  detailsUrl: React.PropTypes.string.isRequired,
  proximityScore: React.PropTypes.number.isRequired,
}

export default StatelessFuncToPureComponent(EstatePopupCard)



/** WEBPACK FOOTER **
 ** ./app/components/EstatePopupCard.jsx
 **/